(function () {
  function patchCartOrigin() {
    try {
      var currentOrigin =
        typeof window !== 'undefined' && window.location && window.location.origin;
      var shopOrigin = typeof window.shopUrl !== 'undefined' ? window.shopUrl : '';
      if (!currentOrigin || !shopOrigin || currentOrigin === shopOrigin) return;
      window.shopUrl = currentOrigin;
      if (window.routes && typeof window.routes === 'object') {
        var o = currentOrigin;
        function toAbsolute(path) {
          if (!path || typeof path !== 'string') return path;
          if (path.indexOf('http') === 0) return path;
          return o + (path.charAt(0) === '/' ? path : '/' + path);
        }
        if (window.routes.cart_url !== undefined)
          window.routes.cart_url = toAbsolute(window.routes.cart_url);
        if (window.routes.cart_add_url !== undefined)
          window.routes.cart_add_url = toAbsolute(window.routes.cart_add_url);
        if (window.routes.cart_change_url !== undefined)
          window.routes.cart_change_url = toAbsolute(window.routes.cart_change_url);
        if (window.routes.cart_update_url !== undefined)
          window.routes.cart_update_url = toAbsolute(window.routes.cart_update_url);
      }
    } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchCartOrigin);
  } else {
    patchCartOrigin();
  }
})();
